// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"e3435329","142":"39beaa1c","638":"7c5f303a","681":"ac1ecf6e","891":"adba2eaf","960":"553fc1b1"}[chunkId] + ".chunk.js";
};